import React from 'react';
import { classes, style } from 'typestyle';
import { SVGIcon } from '../../components/svg-icon';
import { ButtonPill } from '../../components/button-pill';
import closeIcon from '../../static/close.svg';
import copyrightIcon from '../../static/copyright.svg';
import timeIcon from '../../static/access_time.svg';
import mp3Icon from '../../static/mp3.svg';
import dummyImg from '../../static/meduza.jpg';
import { colorBlack, colorSlate } from '../../theme/color';

import { styles } from './styles';
import { Collapsible } from '../collapsible/collapsible';
import { ImageModel } from '../../modules/image/model';
import CheckoutTrackCard from './checkout-track-card';
import { AnalyticsController } from '../../modules/analytics/controller';
import { BasketModel } from '../../modules/basket/model';
import { inject, deps, observer } from '../../lib/component';
import { formatCurrency } from '../../lib/currency';
import { px } from 'csx';
import collapsibleStyles from '../collapsible/styles';
import { TrackSchema } from '../../types/schema';

interface CheckoutCardListProps {
  model: BasketModel;
  coverUrlProvider: ImageModel['cover'];
  onClickLink(event: React.MouseEvent<any>): void;
  onRemoveTrack(identity: string): void;
  handleEulaRequest: (track: TrackSchema) => void;
  handleRightsholderRequest: (track: TrackSchema) => void;
  analytics: AnalyticsController;
}

@observer
class CheckoutCardList extends React.Component<CheckoutCardListProps> {
  render() {
    const {
      model,
      coverUrlProvider,
      onClickLink,
      onRemoveTrack,
      analytics,
      handleEulaRequest,
      handleRightsholderRequest,
    } = this.props;

    const childProps = {
      coverUrlProvider,
      onClickLink,
      onRemoveTrack,
      analytics,
      handleEulaRequest,
      handleRightsholderRequest,
    };

    const { currency, itemPrices, total } = model;

    return (
      <div className={styles.checkoutCardListContainer}>
        <div className={styles.checkoutCardList}>
          <h5>Your Items</h5>
          {model.tracks.map((track) => (
            <CheckoutTrackCard
              key={track.identity}
              model={{ track, price: itemPrices[track.identity], currency }}
              {...childProps}
            />
          ))}
        </div>
        <div className={styles.checkoutSubtotal}>
          <span className={classes(styles.totalText, styles.smallText)}>Sub-total</span>
          <span className={styles.totalText}>{formatCurrency(total, currency)}</span>
        </div>
        <Collapsible className={style({ margin: px(17) })}>
          <Collapsible.Summary indicator={true} className={collapsibleStyles.summaryLabel}>
            <SVGIcon.Warning color={colorBlack.toHexString()} />
            <p>Video privacy settings</p>
          </Collapsible.Summary>
          <div className={styles.checkoutVideoPrivacyDetails}>
            Publish your Youtube videos as <strong>‘Unlisted’</strong> or <strong>‘Public’</strong> so Lickd can clear
            your copyright claim {/*<a href="#">Learn More</a>*/}
          </div>
        </Collapsible>
      </div>
    );
  }
}

export default CheckoutCardList;
